/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import Context from "../../../scripts/context/User";
import axios from "axios";
import {
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import toast from "react-hot-toast";

export default function Disclaimer() {
  const {
    data: checked,
    setData: setChecked,
    handleNext,
    setLoading,
    getRegistrationStep,
  } = useOutletContext();
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { globalState, setGlobalState } = useContext(Context);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    searchParams.get("message") && toast.success(searchParams.get("message"));
  }, [searchParams]);

  useEffect(() => {
    setChecked({
      terms: globalState.registration_step > 2,
    });
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!checked.terms) {
      toast.error("Please accept the terms and conditions");
      setIsError(true);
    } else {
      if (globalState.registration_step > 2) return handleNext();

      setLoading(true);
      axios
        .post("register/disclaimer/confirmDisclaimer")
        .then(() => {
          setLoading(false);
          handleNext();
          setGlobalState({
            ...globalState,
            registration_step: 3,
          });
        })
        .catch(({ response }) => {
          setLoading(false);
          toast.error(response.data.message);
          response.data.redirect_uri && navigate(response.data.redirect_uri);
          getRegistrationStep(response.data.redirect_uri);
        });
    }
  };

  const handleCheck = (event) => {
    setChecked({
      terms: event.target.checked,
    });
  };

  return (
    <form id="Disclaimer" onSubmit={handleSubmit}>
      <div>
        <div
          className="pb-5 text-white"
          style={{ overflow: "auto", maxHeight: "400px" }}
        >
          <div className="pt-lg-0 pt-5 pb-5">
            <h3 className="font-weight-bolder text-white font-size-h2 font-size-h1-lg">
              Legal Disclaimer
            </h3>
            <p>
              The following Terms and Conditions, together with any other terms
              incorporated by reference (the “Terms”) govern your (“You” or the
              “Purchaser”) purchase from BULLIT, a service from CTRL HOLDING
              CORP, Intershore Chambers, Road Town, Tortola, British Virgin
              Islands, Company Registration Nr: 2072012 (‘us’, ‘we’ or the
              “Company”) of cryptographic tokens Bullit (“BULT” or the
              “Tokens”).
              <br />
              <br />
              Purchaser and Company may be referred to as Party or Parties in
              below.
              <br />
              <br /> IF YOU DO NOT AGREE TO THESE TERMS, DO NOT PURCHASE OR MAKE
              OFFERS TO PURCHASE BULT FROM THE COMPANY. IF YOU HAVE ANY
              QUESTIONS REGARDING THESE TERMS, PLEASE CONTACT THE COMPANY AT
              <a href="mailto:support@bullit.app" className="text-primary">
                {" "}
                support@bullit.app
              </a>
              <br />
              <br /> The Parties agree as follows:
            </p>
          </div>
          <div className="form-group jwYTst">
            <form className="sc-furwcr">
              <ol>
                <li>
                  GENERAL
                  <ol>
                    <li>
                      BULT is a cryptographic token to be issued by the Company.
                      BULT is built on the THETA Network (THETA) and its native
                      token standard (TNT20). Purchase of BULT and future
                      handling of the Tokens requires access to generally
                      accepted storage and transmission systems of THETA (THETA)
                      and TNT20 tokens.
                    </li>
                    <li>
                      The Tokens are intended to support the business model as
                      contemplated by the Company, as defined in the white paper
                      (the “White Paper”) provided at https://bullit.app/ (the
                      “Website”) as of the date the Purchaser receives the
                      Tokens. To the extent, they do not contradict these Terms,
                      the rights connected to the Tokens are subject to the
                      limitations set out in the White Paper, but the White
                      Paper creates no obligations for the Company in addition
                      to the ones contained in these Terms.
                    </li>
                    <li>
                      The Tokens can be held and used at the sole discretion of
                      the holder to the extent this does not contradict these
                      Terms. The Company aspires to achieve the milestones
                      described in the White Paper. The Company makes no
                      representations nor warrants that such milestones are
                      achievable or will be achieved.
                    </li>
                    <li>
                      In respect of the tasks described in 1.3 above, the
                      Company has only such obligations and duties as expressly
                      described in these Terms. Other obligations and duties are
                      excluded.
                    </li>
                    <li>
                      The Company is not an investment advisor and does not give
                      investment advice to you.
                    </li>
                    <li>
                      This Agreement contains the complete terms and conditions
                      that apply to your participation in the Token Sale. If
                      there is a conflict between this Agreement and any other
                      additional terms or information available about the Token
                      Sale, this Agreement takes precedence unless such
                      additional terms expressly reference variation to this
                      Agreement.
                    </li>
                  </ol>
                </li>

                <li>
                  CONDITIONS OF SALE
                  <ol>
                    <li>
                      YOU MAY NOT MAKE AN OFFER OR ACQUIRE THE TOKENS IF YOU ARE
                      A CITIZEN, RESIDENT (TAX OR OTHERWISE), OR GREEN CARD
                      HOLDER OF THE UNITED STATES OF AMERICA OR ANY OTHER
                      COUNTRY WHICH LEGISLATION LIMITS OR FORBIDS THE OFFERING,
                      SALE, ACQUISITION OF AND/OR OTHER TRANSACTIONS WITH THE
                      TOKENS OR THE ENVISIONED ACTIVITIES OF THE COMPANY.
                    </li>
                    <li>
                      When you purchase, or otherwise receive the Tokens, you
                      may only do so by accepting the following conditions and,
                      by doing so, You warrant and represent that the following
                      are a true and accurate reflection of the basis on which
                      You are acquiring the Tokens:
                      <ol>
                        <li>
                          the Company did not provide You with any advice
                          regarding whether the Tokens is a suitable investment
                          for you;
                        </li>
                        <li>
                          you have a sufficient understanding of the
                          functionality, usage, storage, transmission
                          mechanisms, and intricacies associated with
                          cryptographic tokens, such as TNT20, as well as
                          blockchain-based software systems generally;
                        </li>
                        <li>
                          you are legally permitted to receive and hold and make
                          use of the Tokens in your and any other relevant
                          jurisdiction;
                        </li>
                        <li>
                          you will supply us with all information,
                          documentation, or copy documentation we require in
                          order to allow us to accept your purchase of and
                          allocation of the Tokens to you;
                        </li>
                        <li>
                          you have not supplied us with information relating to
                          your purchase of BULT or otherwise which is inaccurate
                          or misleading;
                        </li>
                        <li>
                          you will provide us with any additional information
                          which may be reasonably required in order we can
                          fulfill our legal, regulatory, and contractual
                          obligations, including but not limited to any
                          anti-money laundering obligation;
                        </li>
                        <li>
                          you will notify us promptly of any change to the
                          information supplied by you to us;
                        </li>
                        <li>
                          you will comply with our KYC policy and procedural
                          steps as made available on the Website and as amended
                          from time to time at our discretion;
                        </li>
                        <li>
                          you are of sufficient age to legally obtain the
                          Tokens, and you are not aware of any other legal
                          reason to prevent you from purchasing BULT;
                        </li>
                        <li>
                          you take sole responsibility for any restrictions and
                          risks associated with receiving and holding the
                          Tokens, including but not limited to these set out in
                          these Terms;
                        </li>
                        <li>
                          by acquiring BULT, you are not making a regulated
                          investment, as this term may be interpreted by the
                          regulator in your jurisdiction;
                        </li>
                        <li>
                          you are not obtaining or using the Tokens for any
                          illegal purpose, and will not use the Tokens for any
                          illegal purpose;
                        </li>
                        <li>
                          you waive any right you may have or obtain to
                          participate in a class-action lawsuit or class-wide
                          arbitration against any entity or individual involved
                          with the sale or distribution of the Tokens;
                        </li>
                        <li>
                          your acquisition of the Tokens does not involve
                          purchase or receipt of shares, ownership, or any
                          equivalent in any existing or future public or private
                          company, corporation, or other entity in any
                          jurisdiction;
                        </li>
                        <li>
                          to the extent permitted by law and provided we act in
                          good faith, the Company makes no warranty whatsoever,
                          either expressed or implied, regarding the future
                          success of the Company, the Tokens, the THETA Network,
                          and/or achieving any of the aspirations set forth in
                          the White Paper;
                        </li>
                        <li>
                          you accept that the Tokens are created and you obtain
                          the Tokens on an “as is” basis. Therefore, provided
                          the Company acts in good faith, you accept that the
                          Company is providing the Tokens without being able to
                          provide any warranties in relation to the Tokens,
                          including, but not limited to, title, merchantability
                          or fitness for a particular purpose;
                        </li>
                        <li>
                          you accept that you bear sole responsibility for
                          determining if
                          <br />
                          (i) the acquisition, the allocation, use or ownership
                          of the Tokens,
                          <br />
                          (ii) the potential appreciation or depreciation in the
                          value of the Tokens over time, if any,
                          <br />
                          (iii) the sale and purchase of the Tokens, and/or
                          <br />
                          (iv) any other action or transaction related to the
                          Tokens has tax implications. You are solely
                          responsible for performing any and all obligations
                          related to relevant tax implications, including, among
                          other, declaring and paying applicable taxes.
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
                <li>
                  CANCELLATION
                  <ol>
                    <li>
                      Your purchase of BULT from the Company is final, and there
                      are no refunds or cancellations. We reserve the right to
                      refuse or cancel your purchase request at any time at our
                      sole discretion.
                    </li>
                  </ol>
                </li>

                <li>
                  RISKS
                  <ol>
                    <li>
                      You acknowledge and agree there are risks associated with
                      purchasing BULT[1] , owning the Tokens as disclosed and
                      explained in these Terms. BY PURCHASING BULT YOU EXPRESSLY
                      ACKNOWLEDGE AND ASSUME THESE RISKS.
                    </li>
                  </ol>
                </li>

                <li>
                  SECURITY
                  <ol>
                    <li>
                      You are responsible for implementing reasonable measures
                      for securing your wallet or vault you use to receive and
                      hold the Tokens you purchased from the Company, including
                      any requisite private key(s) or other credentials
                      necessary to access such wallet or vault. Notwithstanding
                      any other provision of these Terms, the Company will not
                      be responsible or liable for any damages, losses, costs,
                      penalties, fines or expenses arising out of or relating to
                      (i) your failure to implement reasonable measures to
                      secure your wallets or vaults you use to receive and hold
                      the Tokens or the relevant access credentials or (ii) the
                      loss of or unauthorized use of any of your access
                      credentials.
                    </li>
                  </ol>
                </li>

                <li>
                  REGISTRATION INFORMATION
                  <ol>
                    <li>
                      We may collect certain information from you, including
                      your phone number, email address, and/or wallet address,
                      in connection with your Registration (your “Registration
                      Information”).
                    </li>
                    <li>
                      We may use your Registration Information for determining
                      your eligibility for the Token Sale, determining your
                      compliance with these Terms, providing updates to you
                      regarding the Token Sale, facilitating your purchase of
                      BULT, and use of the Tokens, and providing notices to you
                      under these Terms.
                    </li>
                    <li>
                      We may share your Registration Information as follows: (i)
                      with consultants and other service providers who need
                      access to such information to carry out work on our
                      behalf, (ii) in response to a request for information if
                      we believe disclosure is in accordance with or required
                      by, any applicable law, regulation or legal process, (iii)
                      if we believe your actions are inconsistent with these
                      Terms or to protect the rights, property, and safety of
                      Company or others, (iv) in connection with, or during
                      negotiations of, any merger, sale of company assets,
                      financing or acquisition of all or a portion of our
                      business by another company, (v) between and among Company
                      and our current and future parents, affiliates,
                      subsidiaries, and other companies under common control and
                      ownership and (vi) with your consent or at your direction.
                    </li>
                    <li>
                      You acknowledge that we may obtain some Registration
                      Information from third parties, including your phone
                      number and email address, and you authorize us to use such
                      Registration Information in accordance with these Terms.
                      We are not responsible for the collection, use or sharing
                      of any information that you provide to such third parties
                      or that such third parties collect from you.
                    </li>
                    <li>
                      We may determine, at our sole discretion, that it is
                      necessary to obtain certain other information about you or
                      (if relevant) your family members, beneficiaries,
                      shareholders, beneficial owners, partners, directors,
                      officers, or any other individuals connected to you in
                      order to complete the Token Sale or in order to comply
                      with applicable laws or regulations or requests of any
                      regulator in any relevant jurisdiction. You agree to
                      provide us such information promptly upon request, and any
                      information you provide in respect of any third-party
                      individuals may be collected, used, and disclosed by us in
                      order for us or our corporate affiliates to complete the
                      Token Sale or to comply with laws or regulations or
                      requests of any regulator in any relevant jurisdiction.
                      You acknowledge that we may refuse to sell BULT[2] to you
                      until you provide such requested information and we have
                      determined that it is permissible to sell you BULT under
                      applicable laws or regulations.
                    </li>
                  </ol>
                </li>

                <li>
                  TAXES
                  <ol>
                    <li>
                      Any amounts that you pay for BULT are exclusive of all
                      applicable taxes. You are responsible for determining what
                      if any, taxes apply to your purchase of BULT, including,
                      for example, sales, use, value-added, and similar taxes.
                      It is your responsibility to withhold, collect, report,
                      and remit the correct taxes to the appropriate tax
                      authorities. We are not responsible for withholding,
                      collecting, reporting, or remitting any sales, use,
                      value-added, or similar tax arising from your purchase of
                      BULT.
                    </li>
                  </ol>
                </li>

                <li>
                  REPRESENTATIONS AND
                  <br />
                  WARRANTIES You represent
                  <br /> and warrant that:
                  <ol>
                    <li>
                      You have a sufficient technical understanding of
                      cryptographic tokens (including TNT20), token storage
                      mechanisms (including your identified wallet), and
                      blockchain technology in general to understand these Terms
                      and to appreciate the risks and implications of purchasing
                      BULT;
                    </li>
                    <li>You have read and understood these Terms;</li>
                    <li>
                      You have obtained sufficient information about the Tokens
                      to make an informed decision to purchase BULT;
                    </li>
                    <li>
                      You understand the restrictions and risks associated with
                      the sale of the Tokens as set forth herein, and
                      acknowledge and assume all such risks;
                    </li>
                    <li>
                      You understand, acknowledge and assume the risks
                      associated with the purchase, holding and use of the
                      Tokens, as explained and disclosed in these Terms;
                    </li>
                    <li>
                      You will comply with any applicable tax obligations in
                      your jurisdiction arising from your purchase of BULT;
                    </li>
                    <li>
                      If you are purchasing BULT on behalf of any entity,
                      <br />
                      (i) you are authorized to accept these Terms and to act on
                      such entity’s behalf, <br />
                      (ii) such entity will be responsible for breach of these
                      Terms by you or any other employee or agent of such entity
                      (references to “you” in these Terms refer to you and such
                      entity, jointly), and <br />
                      (iii) such entity is duly organized and validly existing
                      under the applicable laws of the jurisdiction of its
                      organization.
                    </li>
                    <li>
                      You will at all times maintain control of your wallet (if
                      any), and you will not share or disclose the account
                      credentials associated with any other party. If you
                      transfer the Tokens from your wallet into another wallet
                      or vault, you will likewise at all times maintain control
                      of such other wallet or vault, and you will not share or
                      disclose the account credentials associated with such
                      other wallet or vault with any other party; and You accept
                      and acknowledge that title to, and risk of loss of, the
                      Tokens passes from Company to you in the British Virgin
                      Islands.
                    </li>
                  </ol>
                </li>

                <li>
                  INDEMNIFICATION
                  <ol>
                    <li>
                      To the fullest extent permitted by applicable law, you
                      will indemnify, defend and hold harmless the Company and
                      our respective past, present, and future employees,
                      officers, directors, contractors, consultants, equity
                      holders, suppliers, vendors, service providers, parent
                      companies, subsidiaries, affiliates, agents,
                      representatives, predecessors, successors and assigns (the
                      “Company Parties”) from and against all claims, demands,
                      actions, damages, losses, costs and expenses (including
                      attorneys’ fees) that arise from or relate to: <br />
                      (i) your purchase or use of BULT, <br />
                      (ii) your responsibilities or obligations under these
                      Terms,
                      <br />
                      (iii) your violation of these Terms, or <br />
                      (iv) your violation of any rights of, or laws or
                      regulations applicable to, any other person or entity.
                    </li>
                    <li>
                      Company reserves the right to exercise sole control over
                      the defense, at your expense, of any claim subject to
                      indemnification under 9.1. This indemnity is in addition
                      to, and not in lieu of, any other indemnities set forth in
                      a written agreement between you and the Company.
                    </li>
                  </ol>
                </li>

                <li>
                  DISCLAIMERS
                  <ol>
                    <li>
                      TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW AND
                      EXCEPT AS OTHERWISE SPECIFIED IN A WRITING BY US,
                      <br />
                      (A) BULT ARE SOLD ON AN “AS IS” AND “AS AVAILABLE” BASIS
                      WITHOUT WARRANTIES OF ANY KIND, AND WE EXPRESSLY DISCLAIM
                      ALL IMPLIED WARRANTIES AS TO THE TOKENS, INCLUDING,
                      WITHOUT LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY,
                      FITNESS FOR A PARTICULAR PURPOSE, TITLE AND
                      NON-INFRINGEMENT; <br />
                      (B) WE DO NOT REPRESENT OR WARRANT THAT THE TOKENS ARE
                      RELIABLE, CURRENT, OR ERROR-FREE, MEET YOUR REQUIREMENTS,
                      OR THAT DEFECTS IN THE TOKENS WILL BE CORRECTED, AND{" "}
                      <br />
                      (C) WE CAN NOT AND DO NOT REPRESENT OR WARRANT THAT THE
                      TOKENS OR THE DELIVERY MECHANISM FOR THE TOKENS ARE FREE
                      OF VIRUSES OR OTHER HARMFUL COMPONENTS.
                    </li>
                  </ol>
                </li>

                <li>
                  LIMITATION OF LIABILITY
                  <ol>
                    <li>
                      TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW: <br />
                      (I) IN NO EVENT WILL THE COMPANY OR ANY OF THE COMPANY
                      PARTIES BE LIABLE FOR LOSS OF PROFITS OR ANY INDIRECT,
                      SPECIAL, INCIDENTAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES OF
                      ANY KIND (INCLUDING, BUT NOT LIMITED TO, WHERE RELATED TO
                      LOSS OF REVENUE, INCOME OR PROFITS, LOSS OF USE OR DATA,
                      OR DAMAGES FOR BUSINESS INTERRUPTION) ARISING OUT OF OR IN
                      ANY WAY RELATED TO THE SALE OR USE OF THE TOKENS OR
                      OTHERWISE RELATED TO THESE TERMS, REGARDLESS OF THE FORM
                      OF ACTION, WHETHER BASED IN CONTRACT, TORT (INCLUDING, BUT
                      NOT LIMITED TO, NEGLIGENCE OF ANY PARTY), OR ANY OTHER
                      LEGAL OR EQUITABLE THEORY (EVEN IF THE PARTY HAS BEEN
                      ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND REGARDLESS
                      OF WHETHER SUCH DAMAGES WERE FORESEEABLE); AND <br />
                      (II) IN NO EVENT WILL THE AGGREGATE LIABILITY OF COMPANY
                      AND THE COMPANY PARTIES (JOINTLY), WHETHER IN CONTRACT,
                      WARRANTY, TORT (INCLUDING NEGLIGENCE, WHETHER ACTIVE,
                      PASSIVE OR IMPUTED), OR OTHER THEORY, ARISING OUT OF OR
                      RELATING TO THESE TERMS OR THE USE OF OR INABILITY TO USE
                      THE TOKENS, EXCEED THE AMOUNT YOU PAY TO US FOR BULT.
                    </li>
                  </ol>
                </li>

                <li>
                  GOVERNING LAW
                  <ol>
                    <li>
                      These Terms will be governed by and construed and enforced
                      in accordance with the laws of the British Virgin Isles,
                      without regard to conflict of law rules or principles that
                      would cause the application of the laws of any other
                      jurisdiction.
                    </li>
                  </ol>
                </li>

                <li>
                  SEVERABILITY
                  <ol>
                    <li>
                      If any term, clause, or provision of these Terms is held
                      unlawful, void, or unenforceable, then that term, clause,
                      or provision will be severable from these Terms and will
                      not affect the validity or enforceability of any remaining
                      part of that term, clause or provision, or any other term,
                      clause or provision of these Terms.
                    </li>
                  </ol>
                </li>

                <li>
                  DISRUPTION EVENT
                  <ol>
                    <li>
                      In the event of a Disruption Event, we have the right to
                      suspend the Token Sale. If we elect to suspend the Token
                      Sale, we will publicly announce the suspension as soon as
                      reasonably practicable and, prior to resuming the Token
                      Sale, we will announce the resumption at least four (4)
                      hours in advance. If we suspend the Token Sale for a
                      period of time (the “Suspension Period”) pursuant to this
                      Section 14, we will determine in our sole discretion
                      whether to <br />
                      (i) nevertheless end the Token Sale on the scheduled Token
                      Sale end date (as set out in the White Paper) or <br />
                      (ii) extend the Token Sale for a period equal to the
                      Suspension Period. We will provide notice of its election
                      in this regard in the public announcements of the
                      resumption of the Token Sale following the Suspension
                      Period. A “Disruption Event” means <br />
                      <br />
                      (i) any event or occurrence that causes a disruption in
                      the functionality of the blockchain, and such disruption
                      has a material adverse effect on the processing time for
                      blockchain transactions, or <br />
                      (ii) a change in the price of TNT20 of twenty percent
                      (20%) or more in any twenty-four (24) hour period.
                    </li>
                  </ol>
                </li>

                <li>
                  MODIFICATION OF TERMS
                  <ol>
                    <li>
                      We have the right to modify these Terms if we reasonably
                      believe that such modifications are necessary to comply
                      with applicable laws or regulations, to address technical
                      inaccuracies, or for other reasons. If we make changes, we
                      will post the amended Terms at www.bullit.app and update
                      the “Last Updated” date above. We may also provide notice
                      to you via email to the email address you provide during
                      registration. The amended Terms will be effective
                      immediately, and your continued use or holding of the
                      Tokens you purchased shall constitute your acceptance of
                      the modified Terms.
                    </li>
                  </ol>
                </li>

                <li>
                  MISCELLANEOUS
                  <ol>
                    <li>
                      These Terms constitute the entire agreement between you
                      and us relating to your purchase of BULT from us. Our
                      failure to exercise or enforce any right or provision of
                      these Terms will not operate as a waiver of such right or
                      provision. We will not be liable for any delay or failure
                      to perform any obligation under these Terms where the
                      delay or failure results from any cause beyond our
                      reasonable control. We may assign our rights and
                      obligations under these Terms. Purchasing BULT from us
                      does not create any form of partnership, joint venture, or
                      any other similar relationship between you and us. Except
                      as otherwise provided herein, these Terms are intended
                      solely for the benefit of you and us and are not intended
                      to confer third-party beneficiary rights upon any other
                      person or entity. You agree and acknowledge that all
                      agreements, notices, disclosures, and other communications
                      that we provide to you, including these Terms, may be
                      provided in electronic form.
                    </li>
                  </ol>
                </li>

                <li>
                  PRIVACY
                  <ol>
                    <li>
                      The Privacy Policy available on the Website is part of
                      these Terms, and any interaction by the Company with its
                      community and Purchasers and vice versa shall comply with
                      that policy.
                    </li>
                  </ol>
                </li>

                <li>
                  LANGUAGE
                  <ol>
                    <li>
                      Currently, only English versions of any communications
                      with the Company are considered official. The English
                      version shall prevail in case of differences in
                      translation.
                    </li>
                  </ol>
                </li>

                <p className="mt-10">
                  CERTAIN RISKS RELATING TO PURCHASE, SALE, AND USE OF THE
                  TOKENS
                  <br />
                  <br />
                  THE PURCHASE OF THE TOKENS IS SUBJECT TO A HIGH DEGREE OF
                  RISK. THERE CAN BE NO ASSURANCE THAT YOU WILL BE ABLE TO
                  RECEIVE A RETURN OF THEIR CAPITAL OR ANY RETURNS ON THEIR
                  INVESTMENT. PRIOR TO PURCHASING THE TOKENS, YOU SHOULD
                  CAREFULLY CONSIDER THE RISKS ASSOCIATED WITH THE COMPANY, THE
                  TOKENS, AND CRYPTOCURRENCY EXCHANGES, TOGETHER WITH THE OTHER
                  INFORMATION CONTAINED IN THE WHITE PAPER. THE RISK FACTORS
                  DESCRIBED BELOW ARE NOT AN EXHAUSTIVE LIST OR EXPLANATION OF
                  ALL THE RISKS WHICH YOU MAY FACE WHEN PURCHASING THE TOKENS
                  AND SHOULD BE USED AS GUIDANCE ONLY. ADDITIONAL RISKS AND
                  UNCERTAINTIES RELATING TO THE COMPANY AND THE TOKENS THAT ARE
                  NOT CURRENTLY KNOWN TO US, OR THAT WE CURRENTLY DEEM
                  IMMATERIAL, MAY INDIVIDUALLY OR CUMULATIVELY ALSO HAVE A
                  MATERIAL ADVERSE EFFECT ON THE COMPANY’S BUSINESS, OPERATIONS,
                  RESULTS, FINANCIAL CONDITION, OR PROSPECTS AND, IF ANY SUCH
                  RISK SHOULD OCCUR, YOU COULD LOSE ALL OR PART OF YOUR
                  INVESTMENT. YOU SHOULD CONSIDER CAREFULLY WHETHER AN
                  INVESTMENT IN THE TOKENS IS SUITABLE FOR YOU IN THE LIGHT OF
                  YOUR PERSONAL CIRCUMSTANCES.
                </p>
              </ol>
              <ol>
                <li>
                  Risk of Losing Access to the Tokens Due to Loss of Private
                  Key(s), Custodial Error, or Purchaser Error
                  <br />
                  <br />A private key, or a combination of private keys, is
                  necessary to control and dispose of the Tokens stored in your
                  digital wallet or vault. Accordingly, loss of requisite
                  private key(s) associated with your digital wallet or vault
                  storing the Tokens will result in loss of such the Tokens.
                  Moreover, any third party that gains access to such private
                  key(s), including by gaining access to login credentials of a
                  digital wallet or vault service you use, may be able to
                  misappropriate your Tokens. Any errors or malfunctions caused
                  by or otherwise related to the digital wallet or vault you
                  choose to receive and store the Tokens, including your own
                  failure to properly maintain or use such digital wallet or
                  vault, may also result in the loss of your Tokens.
                </li>
                <li>
                  Risks Associated with the THETA Network Protocol
                  <br />
                  <br />
                  Because the Tokens are based on the THETA Network and its
                  TNT20 protocol, any malfunction, breakdown, or abandonment of
                  the protocol may have a material adverse effect on the
                  platform or the Tokens. Moreover, advances in cryptography, or
                  technical advances such as the development of quantum
                  computing could present risks to the Tokens and the platform,
                  including the utility of the Tokens for obtaining Services, by
                  rendering ineffective the cryptographic consensus mechanism
                  that underpins the TNT20 protocol.
                </li>
                <li>
                  Risk of Hacking and Security Weaknesses
                  <br />
                  <br />
                  Hackers or other malicious groups or organizations may attempt
                  to interfere with the Tokens in a variety of ways, including,
                  but not limited to, malware attacks, denial of service
                  attacks, consensus-based attacks, Sybil attacks, smurfing, and
                  spoofing.
                </li>
                <li>
                  Risk of Uninsured Losses
                  <br />
                  <br />
                  Unlike bank accounts or accounts at some other financial
                  institutions, the Tokens are uninsured unless you specifically
                  obtain private insurance to insure them. Thus, in the event of
                  loss or loss of utility value, there is no public insurer or
                  private insurance arranged by us, to offer recourse to you.
                </li>
                <li>
                  Risks Associated with Uncertain Regulations and Enforcement
                  Actions
                  <br />
                  <br />
                  The regulatory status of the Tokens and distributed ledger
                  technology is unclear or unsettled in many jurisdictions. It
                  is difficult to predict how or whether regulatory agencies may
                  apply existing regulation with respect to such technology and
                  its applications. It is likewise difficult to predict how or
                  whether legislatures or regulatory agencies may implement
                  changes to law and regulation affecting distributed ledger
                  technology and its applications, including the Company and the
                  Tokens. Regulatory actions could negatively impact the Tokens
                  in various ways, including, for purposes of illustration only,
                  through a determination that the Tokens are a regulated
                  financial instrument or security that requires registration
                  and/or licensing. The Company may cease operations in a
                  jurisdiction in the event that regulatory actions, or changes
                  to law or regulation, make it illegal to operate in such
                  jurisdiction, or commercially undesirable to obtain the
                  necessary regulatory approval(s) to operate in such
                  jurisdiction.
                </li>
                <li>
                  Risks Arising from Taxation
                  <br />
                  <br />
                  The tax characterization of the Tokens is uncertain. You must
                  seek your own tax advice in connection with purchasing the
                  Tokens, which may result in adverse tax consequences to you,
                  including withholding taxes, income taxes, and tax reporting
                  requirements.
                </li>
                <li>
                  Risk of Insufficient Interest in the Tokens or Distributed
                  Applications
                  <br />
                  <br />
                  It is possible that the Tokens will not be used by a large
                  number of individuals, companies, and other entities or that
                  there will be limited public interest in the creation and
                  development of distributed platforms (such as the Tokens) more
                  generally. Such a lack of use or interest could negatively
                  impact the development of the Tokens and the potential utility
                  of the Tokens.
                </li>
                <li>
                  Risks Associated with the Development and Maintenance of the
                  Tokens
                  <br />
                  <br />
                  The Tokens are still under development and may undergo
                  significant changes over time. Although we intend the Tokens
                  to follow the specifications set forth in the White Paper and
                  will take commercially reasonable steps toward those ends, we
                  may have to make changes to the specifications of the Tokens
                  for any number of legitimate reasons. This could create the
                  risk that the Tokens, as further developed and maintained, may
                  not meet your expectations at the time of purchasing the
                  Tokens. Furthermore, despite our good faith efforts to develop
                  and maintain the Tokens, it is still possible that the Tokens
                  will experience malfunctions or otherwise fail to be
                  adequately developed or maintained, which may negatively
                  impact the Tokens and the potential utility of the Tokens.
                </li>
                <li>
                  Risk of Dissolution of the Company
                  <br />
                  <br />
                  It is possible that, due to any number of reasons, including,
                  but not limited to, the failure of commercial relationships,
                  or intellectual property ownership challenges, the Tokens may
                  no longer be viable to operate, and the Company may dissolve.
                </li>
                <li>
                  Risks Arising from Lack of Governance Rights
                  <br />
                  <br />
                  Since the Tokens confer no governance rights of any kind with
                  respect to the Tokens or Company, all decisions involving the
                  Tokens or Company will be made by Company at its sole
                  discretion, including, but not limited to, decisions to
                  discontinue the Tokens, to sell more Tokens or to sell or
                  liquidate the Company. These decisions could adversely affect
                  the Tokens that you hold, including the Tokens utility.
                </li>
                <li>
                  Unanticipated Risks
                  <br />
                  <br />
                  Cryptographic tokens such as the Tokens are a new and untested
                  technology. In addition to the risks included in these Terms,
                  there are other risks associated with your purchase, holding,
                  and use of the Tokens, including those that the Company cannot
                  anticipate. Such risks may further materialize as
                  unanticipated variations or combinations of the risks
                  discussed in these Terms.
                </li>
              </ol>
              <p>
                CTRL HOLDING CORP
                <br />
                <br />
                Intershore Chambers
                <br />
                <br />
                Road Town
                <br />
                <br />
                Tortola
                <br />
                <br />
                British Virgin Islands
                <br />
                <br />
                Company Registration Nr: 2072012
                <br />
                <br />
              </p>
            </form>
          </div>
        </div>
      </div>
      <div className="form-group d-flex flex-wrap justify-content-between align-items-center px-0 mt-10">
        <div className="checkbox-inline">
          <label
            className={`checkbox checkbox-outline checkbox-white ${
              isError ? "text-red" : "text-white"
            } m-0`}
          >
            <input
              required
              type="checkbox"
              checked={checked.terms || false}
              onChange={handleCheck}
            />
            <span></span>I am aware of the risks and accept personal
            responsibility for my decisions
          </label>
        </div>
      </div>
    </form>
  );
}
